import { EnvironmentInjector, Injectable, inject, runInInjectionContext } from '@angular/core';
import { Auth, signInWithEmailAndPassword, signOut } from '@angular/fire/auth';
import { from, map, Observable } from 'rxjs';

import { AuthApi } from './auth.api';

@Injectable({ providedIn: 'root' })
export class FirebaseAuthApi implements AuthApi {
  private readonly auth = inject(Auth);
  private readonly injector = inject(EnvironmentInjector);

  login(email: string, password: string): Observable<{ uid: string }> {
    return from(
      runInInjectionContext(this.injector, () => signInWithEmailAndPassword(this.auth, email, password))
    ).pipe(
      map((cred) => ({ uid: cred.user.uid }))
    );
  }

  logout(): Observable<void> {
    return from(runInInjectionContext(this.injector, () => signOut(this.auth)));
  }
}
